export default "__VITE_ASSET__DZDAcUr$__"